import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "bt" }

import { ref, computed, onMounted } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// import "./tzjs_fy/javascript/jquery-1.9.1.min.js"
// import "./tzjs_fy/javascript/bookmark_config.js"
// import "./tzjs_fy/javascript/config.js"
// import "./tzjs_fy/javascript/LoadingJS.js"
// import "./tzjs_fy/javascript/main.js"

onMounted(() => {
  setTimeout(() => {
    console.log("injectScriptToIframeinjectScriptToIframe");

    const iframe = document.getElementById("myIframe");
    console.log("iframe",iframe);

    if (!iframe || !iframe.contentDocument) return;

    const iframeDoc = iframe.contentDocument;

    // 注入外部 JS 文件（如 CDN 或本地文件）
    const externalLink1 = document.createElement("link");
    const externalLink2 = document.createElement("link");
    const externalLink3 = document.createElement("link");
    const externalLink4 = document.createElement("link");
    externalLink1.setAttribute("rel", "stylesheet");
    externalLink2.setAttribute("rel", "stylesheet");
    externalLink3.setAttribute("rel", "stylesheet");
    externalLink4.setAttribute("rel", "stylesheet");

    const externalScript1 = document.createElement("script");
    const externalScript2 = document.createElement("script");
    const externalScript3 = document.createElement("script");
    const externalScript4 = document.createElement("script");
    const externalScript5 = document.createElement("script");
    //const externalScript6 = document.createElement("script");

    externalScript1.src = "/tzjs_fy/javascript/jquery-1.9.1.min.js";
    externalScript2.src = "/tzjs_fy/javascript/config.js";
    externalScript3.src = "/tzjs_fy/javascript/bookmark_config.js";
    externalScript4.src = "/tzjs_fy/javascript/LoadingJS.js";
    externalScript5.src = "/tzjs_fy/javascript/main.js";
    //externalScript6.src = "./tzjs_fy/javascript/data2.js";
  
    externalLink1.href = "/tzjs_fy/style/style.css"
    externalLink2.href = "/tzjs_fy/style/player.css"
    externalLink3.href = "/tzjs_fy/style/phoneTemplate.css"
    externalLink4.href = "/tzjs_fy/style/template.css"

    iframeDoc.body.appendChild(externalLink1);
    iframeDoc.body.appendChild(externalLink2);
    iframeDoc.body.appendChild(externalLink3);
    iframeDoc.body.appendChild(externalLink4);
    iframeDoc.body.appendChild(externalScript1);
    iframeDoc.body.appendChild(externalScript2);
    iframeDoc.body.appendChild(externalScript3);
    iframeDoc.body.appendChild(externalScript4);
    iframeDoc.body.appendChild(externalScript5);

  }, 200);
});

// 状态管理
const activeFrame = ref(1); // 1: 自贸区, 2: 综保区

// 计算当前iframe的src地址
const currentSrc = computed(() => {
  if (activeFrame.value === 1) {
    return "http://221.176.156.139:12000/tzjs_fy.jspx";
  } else {
    return "http://221.176.156.139:12000/zbq_tzjs.jspx";
  }
});

// 切换iframe内容
const changeIframe = (num) => {
  activeFrame.value = num;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeIframe(1))),
        style: _normalizeStyle({ fontWeight: activeFrame.value === 1 ? '600' : 'normal' })
      }, " 投资决策参考(自贸区) ", 4),
      _cache[1] || (_cache[1] = _createElementVNode("iframe", {
        src: "/tz2",
        id: "myIframe"
      }, null, -1))
    ])
  ]))
}
}

})